import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import LinkAccountConfirmModal from "./LinkAccountConfirmModal";

const InternalCampaignModal = ({
  show,
  setShow,
  internalCampaigns,
  linkUserAndAssociateCapaign,
}) => {
  const headers = [
    { label: "Name", key: "name" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Actions", key: "actions" },
  ];
  const [loading, setLoading] = useState();
  const [currentCampaign, setCurrentCampaign] = useState({});
  const [showConfirmLinkingModal, setShowConfirmLinkingModal] = useState(false);


  const handleLinkingCampaignn = async (currentIndex, campaign) => {
    setCurrentCampaign(campaign);
    setShowConfirmLinkingModal(true);
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
       
          <div className="d-flex flex-column gap-1">
            <span className="fs-4 fw-bold">
              Link with campaigns on UI platform
            </span>
            <small className="fs-8">
              Select an internal campaign to link with your chosen Google Ads campaign.
            </small>
          </div>
        </Modal.Header>
        <Modal.Body className="overflow-auto" style={{ height: "50vh" }}>
          <div className="card-lg bg-light">
            <div className="table-responsive text-nowrap card-body py-0">
              <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
                <thead>
                  <tr className="fw-bold text-muted bg-light">
                    {headers.map((header) => (
                      <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                       {header.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {internalCampaigns?.length === 0 ? (
                    <tr>
                      <td colSpan={headers.length} className="text-center text-muted">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    internalCampaigns?.map((campaign, index) => {
                      // Use `index` from map as the unique identifier for the row.
                      return (
                        <tr key={campaign?.campaign_id}>
                          <td>{campaign?.campaign_name}</td>
                          <td>{campaign?.start_date}</td>
                          <td>{campaign?.end_date}</td>
                          <td className="d-flex justify-content-end">
                            <button
                              className="btn btn-sm rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center"
                              style={{ width: "150px" }}
                              onClick={async () => {
                                // handleLinkingCampaignn is called with the current index and campaign data
                                handleLinkingCampaignn(index, campaign);
                              }}
                              disabled={loading} // Use `index` to track the loading state for each row
                            >
                              <span>Link</span>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>

      </Modal>

      <LinkAccountConfirmModal
        currentCampaign={currentCampaign}
        showModal={showConfirmLinkingModal}
        setShowModal={setShowConfirmLinkingModal}
        linkUserAndAssociateCapaign={linkUserAndAssociateCapaign}
        setLoading={setLoading}
        loading={loading}
      />
    </div>
  );
};

export default InternalCampaignModal;
